"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var MSSharePoint = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.ImpureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.548 9.057a4.528 4.528 0 1 0 0-9.057 4.528 4.528 0 0 0 0 9.057Z",
    fill: "#036C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.075 12.68a3.924 3.924 0 1 0 0-7.85 3.924 3.924 0 0 0 0 7.85Z",
    fill: "#1A9BA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15 15.396a3.32 3.32 0 1 0 0-6.64 3.32 3.32 0 0 0 0 6.64Z",
    fill: "#37C6D0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.443 4.452v7.668c0 .039-.003.078-.012.116a.674.674 0 0 1-.666.562H4.909a3.192 3.192 0 0 1-.05-.291 2.403 2.403 0 0 1-.026-.291c-.003-.047-.003-.093-.003-.14a3.322 3.322 0 0 1 2.05-3.068 4.531 4.531 0 0 1-3.796-5.234h4.68a.677.677 0 0 1 .679.678Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.734 4.452v7.086a.978.978 0 0 1-.97.969H4.86a2.406 2.406 0 0 1-.026-.291c-.003-.047-.003-.093-.003-.14a3.322 3.322 0 0 1 2.05-3.068 4.531 4.531 0 0 1-3.738-5.525h4.623a.973.973 0 0 1 .97.969Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.443 4.452v7.085a.677.677 0 0 1-.678.679H4.833c-.003-.047-.003-.093-.003-.14a3.322 3.322 0 0 1 2.05-3.068 4.531 4.531 0 0 1-3.796-5.234h4.68a.677.677 0 0 1 .679.678Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.152 4.452v7.085a.677.677 0 0 1-.678.679h-2.64c-.004-.047-.004-.093-.004-.14a3.322 3.322 0 0 1 2.05-3.068 4.531 4.531 0 0 1-3.796-5.234h4.39a.677.677 0 0 1 .678.678Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.472 3.774H.679A.68.68 0 0 0 0 4.453v6.793c0 .375.304.679.68.679h6.792a.68.68 0 0 0 .68-.68V4.454a.68.68 0 0 0-.68-.68Z",
    fill: "#038387"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02 7.875a1.169 1.169 0 0 1-.364-.384 1.042 1.042 0 0 1-.126-.525c-.008-.248.076-.49.235-.68.167-.19.384-.332.625-.408.276-.09.565-.136.855-.133.381-.014.762.04 1.125.158v.795a1.758 1.758 0 0 0-.51-.208 2.47 2.47 0 0 0-.595-.072 1.29 1.29 0 0 0-.611.13.402.402 0 0 0-.243.367c-.001.097.036.19.103.26.08.083.173.15.277.199a8.95 8.95 0 0 0 .593.259c.228.089.447.197.655.323.159.098.291.231.388.39.099.18.147.383.14.588.01.255-.067.505-.22.708a1.231 1.231 0 0 1-.59.396 2.667 2.667 0 0 1-.84.123c-.255 0-.51-.02-.76-.063a2.61 2.61 0 0 1-.618-.179v-.84c.19.136.4.237.625.299.223.069.454.106.688.11.216.013.431-.032.623-.133a.418.418 0 0 0 .21-.373.399.399 0 0 0-.117-.286 1.193 1.193 0 0 0-.325-.226c-.138-.07-.342-.161-.612-.274a3.479 3.479 0 0 1-.612-.32Z",
    fill: "#fff"
  })));
});
var _default = MSSharePoint;
exports["default"] = _default;